<template>
    <div id="interactive-map" class="InteractiveMap">
        <slot/>
    </div>
</template>

<script>
export default {
  name: 'InteractiveMap',
  props: {
    spaces: {
      type: Array,
      required: true
    },
  },
  mounted() {
    const map = document.querySelector('#interactive-map svg');
    const groups = map.querySelectorAll('#map-blocks > g');

    groups.forEach( group => {
      group.id && group.addEventListener('click', (event) => {
        let slug = group.id;

        if(this.$enums.Spaces.BACKLOT === event.target) {
          slug = this.$enums.Spaces.BACKLOT;
        }
        else if (this.$enums.Spaces.STUDIO === slug) {
          group.querySelectorAll('g').forEach( (studio) => {
            if(studio.id.indexOf(this.$enums.Spaces.STUDIO) > -1 ) {
              if(studio.contains(event.target)) {
                slug = studio.id;
              }
            }
          })
        }
        this.$emit('spaceHoveredChange', {slug, type: 'focus', target: event.target, area: null})
      });

      group.id && group.addEventListener('mouseover', (event) => {
        let  slug = group.id;
        if(event.target.id === this.$enums.Spaces.BACKLOT) {
          slug = this.$enums.Spaces.BACKLOT
        }
        else if (this.$enums.Spaces.STUDIO === slug) {
          group.querySelectorAll('g').forEach( (studio) => {
            if(studio.id.indexOf(this.$enums.Spaces.STUDIO) > -1 ) {
              if(studio.contains(event.target)) {
                slug = studio.id;
              }
            }
          })
        }
        this.$emit('spaceHoveredChange', {slug, type: 'hover', target: event.target, area: null})
      });

      group.id && group.addEventListener('mouseleave', (event) => {
        const slug = null;
        this.$emit('spaceHoveredChange', {slug, type: 'hover'})
      });

    });
  },
  methods: {
    changeFocusedSpace(group) {
      const map = document.querySelector('#interactive-map svg');
      let blockActive = map.querySelectorAll('.is-active');

      if(blockActive) {
        blockActive.forEach((block) => {
          block.classList.remove('is-active')
        })
      }
      group.classList.add('is-active')
    },
  }
}
</script>